import React from 'react'
import Toolbar from './toolbar'

const FlexWhitelist = props => {
  return <Toolbar name='FlexWhitelist' />
}

export default FlexWhitelist
